<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Referrals",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Referrals",
            items: [
               {
                  text: "Marketing Staffs",
                  href: "/marketing-staffs",
               },  
               {
                  text: "Referrals",
                  active: true,
               },                   
            ],

            referrals: [],  
            marketing_staff: {},          

            from: null,
            to: null,
            total: null,
            pagination: {},
            
            keyword: "",
            showsearch: false,
            listing_length: 10,
            token: "",
            errors: {},          
            active_page_url: null,
         };
      },
      mounted() {
    
      },

      created() {
         this.fetchReferrals();
      },

      methods: {
         fetchReferrals(page_url = null) {

            this.getToken();
            let url = "api/admin/marketingstaff/referrals?marketing_staff_id=" + this.$route.params.id + "&limit=" + this.listing_length + "&keyword=" + this.keyword;

            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;
            this.loading = true;
            
            this.$axios
               .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.referrals = responseData.marketing_staff_referrals.data;       
                  this.marketing_staff = responseData.marketing_staff;       

                  this.pagination = responseData.marketing_staff_referrals.links;
                  this.from = responseData.marketing_staff_referrals.from;
                  this.to = responseData.marketing_staff_referrals.to;
                  this.total = responseData.marketing_staff_referrals.total;
               
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         }, 

         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>-->
                     

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-md-7">
                        <h5>{{marketing_staff.marketing_staff_name}}</h5>
                        <p>Mob: +91 {{marketing_staff.marketing_staff_mobile}}<br>
                           Email: {{marketing_staff.marketing_staff_email}}</p>
                     </div>
                     <div class="col-5">
                        <router-link :to="{ name: 'marketingstaffs' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change="fetchReferrals()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchReferrals()"/>
                           </label>
                        </div>                     
                        
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->
               

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <th>S.I. No</th>
                              <th>Patient</th>   
                              <th>Contact</th>                              
                              <th>Created on</th>
                              <th>Options</th>
                           </tr>
                        </thead>
                        <tbody v-if="Boolean(referrals.length)">
                           <tr v-for="(referral, index) in referrals" :key="referral.id">
                              <td>{{index  + from}}
                              <td>{{referral.patient_name}}</td>
                              <td>
                                 {{referral.patient_country_code}} {{referral.patient_mobile}}<br>
                                 {{referral.patient_email}}
                              </td>
                              
                              <td>{{referral.created_at | formatDateTime}}</td>
                             
                              <td>
                                 <router-link :to="{ name: 'patients.details', params: {id: referral.patient_id} }" class="btn btn-primary me-2 mb-2 btn-sm">Patient Details</router-link>
                              </td>
                           </tr>
                 
                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="5" class="text-center">No referrals found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts ---> 
                  <caption v-if="Boolean(referrals.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchReferrals(page.url + '&marketing_staff_id=' + $route.params.id + '&limit=' + listing_length + '&keyword=' + keyword )">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->   

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
